module.exports = __webpack_public_path__ + "media/images/zip-icon-5522f9365672565eb9e24bd8c36a769b.png";